import "../css/style.scss"
import "../components/SiteLogo/SiteLogo"
import "../components/SubscribeForm/SubscribeForm"
import "../components/SectionHeader/SectionHeader"
import "../components/IconMarqee/IconMarqee"
import "../components/CTAButton/CTAButton"
import "../components/CustomSection/CustomSection"
import "../components/CustomHeroSection/CustomHeroSection"
import "../components/CustomMediaSection/CustomMediaSection"
import "../components/Products/ProductAutoGrid/ProductAutoGrid"
import "../components/Products/ProductAutoGridFeatured/ProductAutoGridFeatured"
import "../components/Products/ProductCard/ProductCard"
import "../components/Products/ProductLinkCard/ProductLinkCard"
import "../components/Products/ProductLinkCardFeatured/ProductLinkCardFeatured"
import "../components/CustomCheckbox/CustomCheckbox"
import SiteUI from './modules/SiteUI'
import SiteHeader from './modules/SiteHeader'
import SiteFooter from './modules/SiteFooter'
import Search from './modules/Search'
import Login from './modules/Login'
import Register from './modules/Register'
import Cart from './modules/Cart'
import Modal from './modules/Modal'
import Contact from './modules/Contact'
import Produce from './modules/Produce'
import NomadKitchens from './modules/NomadKitchens'
import Newsletter from './modules/Newsletter'


const ui = new SiteUI();

const siteHeader = new SiteHeader();

const siteFooter = new SiteFooter();

const search = new Search();

const login = new Login();

const register = new Register();

const cart = new Cart();

const contact = new Contact();

const produce = new Produce();

const nk = new NomadKitchens();

const newsletter = new Newsletter();

ui.show();


// npx browser-sync start --proxy "http://jamaicaprimefoods.local" --files "**/*.css, **/*.php, **/*.js"